// extracted by mini-css-extract-plugin
export default {"order_item":"order-list_order_item__+FrDG","order_item_row":"order-list_order_item_row__ubsPx","order_item_row_total":"order-list_order_item_row_total__4R0tG"};